import * as Actions from 'reducks/store/actions'
import { initialState } from 'reducks/reduxStore/initialState'

export const StoreReducer = (state = initialState.store, action: any) => {
  switch (action.type) {
    case Actions.FETCH_STORES:
      return {
        ...state,
        stores: [...action.payload],
      }
    case Actions.SAVE_STORE_INFORMATION:
      return {
        ...state,
        ...action.payload,
      }
    case Actions.SET_STORE:
      return {
        ...state,
        ...action.payload,
      }
    case Actions.UPDATE_PUBLISH_FIRST_STOCK:
      return {
        ...state,
        is_before_publishing_stock: action.payload.is_before_publishing_stock,
      }
    case Actions.UPDATE_BUSINESS_HOURS:
      return {
        ...state,
        holidays: [...action.payload.holidays],
        business_hours: { ...action.payload.business_hours },
        order_start_time: { ...action.payload.order_start_time },
        last_order_time: { ...action.payload.last_order_time },
        last_pickup_time: { ...action.payload.last_pickup_time },
      }
    case Actions.UPDATE_SHOPPING_BAGS:
      return {
        ...state,
        shopping_bags: [...action.payload],
      }
    case Actions.INIT_STORE:
      return {
        ...initialState.store,
      }
    default:
      return state
  }
}
